module.exports = __webpack_public_path__ + "static/media/naivna-pedagogika.50e9762c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/naivna-pedagogika.png
// module id = 518
// module chunks = 0